import React from "react";
import { renderToString } from "react-dom/server";
import { styled } from "@linaria/react";
import formatDate from "../../i18n/formatDate";

const Title = styled.span`
  font-weight: 600;
  display: block;
`;

const Date = styled.span`
  font-weight: 500;
`;

const PlotLineLabel = (title: string | null, date: number, timeZone: string) =>
  renderToString(
    <>
      {title === null ? null : <Title>{title}</Title>}
      <Date>{formatDate(date, "datetime", timeZone)}</Date>
    </>,
  );

export default PlotLineLabel;
